import {Fragment} from 'react';

import {LicenseService as Service} from './LicenseService';

import {useToolbar} from '../../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../../shared/hooks/DataTable';

export const List = () => {

  const header = 'Bản quyền';
  const dataKey = 'id';

  const {render: renderDataTable, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'companyName', header: 'Tên doanh nghiệp', matchMode: 'contains', style: {minWidth: '250px'}},
      {field: 'licenseKey', header: 'Serial', matchMode: 'contains', style: {minWidth: '250px'}},
      {field: 'invoiceQuantity', header: 'Số lượng cấp', matchMode: 'contains', style: {minWidth: '100px'}},
      {field: 'productName', header: 'Sản phẩm', matchMode: 'contains', style: {minWidth: '150px'}},     
      {field: 'issueDate', header: 'Ngày cấp', matchMode: 'contains', style: {minWidth: '150px'}, dataType: 'date'},
      {field: 'licenseStartDate', header: 'Ngày bắt đầu', matchMode: 'contains', style: {minWidth: '150px'}, dataType: 'date'},
      {field: 'licenseEndDate', header: 'Ngày hết hạn', matchMode: 'contains', style: {minWidth: '150px'}, dataType: 'date'},
      {field: 'numberDevice', header: 'Thiết bị', matchMode: 'contains', style: {width: '120px'}},
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {renderToolbar} = useToolbar({
    dataKey,
    reloadLazyData,
    selectedItems
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
    </Fragment>
  )
}
